$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/income-statement/'+param+'?period=quarter&limit=4&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      
      var Stat_Revenue_calc = 0;
      var Stat_NetIncome_calc = 0;
      var Stat_epsdiluted_calc = 0;
      var Stat_grossProfit_calc = 0;
      var Stat_operatingIncome_calc = 0;      
      var Stat_incomeBeforeTax_calc = 0;      
      var Stat_ebitda_calc = 0;      
      var Stat_ebit_calc = 0; 
      var Stat_Shares_out = new Array;
     
      
      $.each(data, function(i, elem){

         Stat_Revenue_calc = Stat_Revenue_calc + elem.revenue;
         Stat_NetIncome_calc = Stat_NetIncome_calc + elem.netIncome;
         Stat_epsdiluted_calc = Stat_epsdiluted_calc + elem.epsdiluted;        
         Stat_grossProfit_calc = Stat_grossProfit_calc + elem.grossProfit;                 
         Stat_operatingIncome_calc = Stat_operatingIncome_calc + elem.operatingIncome;                          
         Stat_incomeBeforeTax_calc = Stat_incomeBeforeTax_calc + elem.incomeBeforeTax;                                  
         Stat_ebitda_calc = Stat_ebitda_calc + elem.ebitda;                          
         Stat_ebit_calc = Stat_ebit_calc + elem.ebitda - elem.depreciationAndAmortization;        

         var Stat_Shares_out_array = elem.weightedAverageShsOutDil;
         if (!isNaN(Stat_Shares_out_array)) {
         Stat_Shares_out.push([Stat_Shares_out_array]);};
      
      });
      
      var Stat_Shares = nFormatter(Stat_Shares_out[0], 2)
      $('#shares_out').append(Stat_Shares);
      
      var Stat_Revenue = nFormatter(Stat_Revenue_calc, 2);
      $('#stat_revenue').append(Stat_Revenue);
      $('#total_rev').append(Stat_Revenue);
      $('#total_rev2').append(Stat_Revenue);      

      var Stat_netIncome = nFormatter(Stat_NetIncome_calc, 2);
      $('#stat_net_income').append(Stat_netIncome);
      $('#ni').append(Stat_netIncome);      
      $('#ni2').append(Stat_netIncome);            

      var Stat_epsdiluted = nFormatter(Stat_epsdiluted_calc, 2);
      $('#stat_earnings_per_share').append(Stat_epsdiluted);
      $('#eps').append(Stat_epsdiluted);
      $('#eps2').append(Stat_epsdiluted);      

      var Stat_grossProfit = nFormatter(Stat_grossProfit_calc, 2);
      $('#stat_gross_profit').append(Stat_grossProfit);

      var Stat_operatingIncome = nFormatter(Stat_operatingIncome_calc, 2);
      $('#stat_operating_income').append(Stat_operatingIncome);      

      var Stat_incomeBeforeTax = nFormatter(Stat_incomeBeforeTax_calc, 2);
      $('#stat_pretax_income').append(Stat_incomeBeforeTax);            

      var Stat_ebitda = nFormatter(Stat_ebitda_calc, 2);
      $('#stat_ebitda').append(Stat_ebitda);            

      var Stat_ebit = nFormatter(Stat_ebit_calc, 2);
      $('#stat_ebit').append(Stat_ebit);   

      var Stat_ebitda_margin = Stat_ebitda_calc / Stat_Revenue_calc;
      var ebitda_margin_var = Stat_ebitda_margin.toLocaleString('en-US', {style: 'percent', minimumFractionDigits:2});
      $('#stat_ebitda_margin').append(ebitda_margin_var);           
      
      
    })
});